import { useAppDispatch, useAppSelector } from "./redux";
import commonservice from "@apis/commonservice";
import { getProfile } from "@apis/http/api";
import EmailVertifyModal from "@components/EmailVertifyModal";
import { useModalTip } from "@components/ModalAutoAlert";
import report from "@report";
import { queryMembership, updateUserInfo } from "@store/globalSlice";
import { queryMemberships } from "@store/memberCenterSlice";
import { LoginMethodStorage } from "@utils/storage";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const useVerifyEmail = ({
  verifySuccess,
  verifyError,
}: {
  verifySuccess?: Function;
  verifyError?: Function;
}) => {
  const [open, setOpen] = useState(false);
  const { userInfo: _userInfo, region } = useAppSelector((state) => state.globalReducer);
  const dispatch = useAppDispatch();
  const successModalTip = useModalTip({
    type: "confirm",
    title: "Verified successfully",
    subtitle: "You can also log in with this Email.",
  });
  const { t } = useTranslation();
  const errorModalTip = useModalTip({
    type: "error",
    title: "Authorized failure",
  });
  // 邮箱验证
  const onVertifyEmail = async (formData: { email: string; prefix: string; captcha: string }) => {
    const params: {
      email?: string;
      emailCode?: string;
      loginMethod: "SMS" | "TIKTOK" | "EMAIL";
    } = {
      email: formData.email,
      loginMethod: "EMAIL",
      emailCode: formData.captcha,
    };
    return commonservice
      .verifyAccount(params)
      .then(() => {
        report.event("email_vericaty_success", {
          kalo_type: params.loginMethod,
        });
        verifySuccess?.();
        LoginMethodStorage("email");
        setOpen(false);
        if (!location.pathname.includes("/pricing")) {
          successModalTip.open({
            type: "confirm",
            title: "Verified successfully",
            subtitle: "You can also log in with this Email.",
          });
        }
        getProfile().then((res) => {
          dispatch(updateUserInfo(res));
          dispatch(queryMembership({ country: region }));
          dispatch(queryMemberships());
        });
      })
      .catch((err) => {
        report.event("phone_vericaty_error", {
          kalo_type: params.loginMethod,
          kalo_value: err,
        });
        verifyError?.(err);
        if (err.code == "1114") {
          err.message = t("The Email account is linked to another account. You can try another Email account.");
          errorModalTip.open({
            title: "Verified unsuccessfully",
            subtitle: t(err.message),
          });
          return;
        }
        throw err.message || err;
      });
  };

  const verifyEmailModal = () => {
    return (
      <>
        <EmailVertifyModal onSubmit={onVertifyEmail} setOpen={setOpen} open={open} />
        {successModalTip.showDom()}
        {errorModalTip.showDom()}
      </>
    );
  };

  return {
    setOpen,
    open,
    verifyEmailModal,
  };
};
